import React from 'react';

import { SvgIcon, type SxProps } from '@mui/material';

type Props = {
  sx?: SxProps;
};
export default function ProgressBarOutlined({ sx }: Props) {
  return (
    <SvgIcon sx={sx}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.8889 17L3.11111 17C2.5 17 2 16.55 2 16L2 8C2 7.45 2.5 7 3.11111 7L20.8889 7C21.5 7 22 7.45 22 8L22 10L22 14L22 16C22 16.55 21.5 17 20.8889 17ZM19.7778 15L19.7778 9L10.3333 9L10.3333 15L19.7778 15Z"
          fill="currentcolor"
        />
      </svg>
    </SvgIcon>
  );
}
